import { Box, Grid } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import logoNav2 from '../../../assets/images/logo-nav2.svg';
import Loader from '../../../components/Loader/Loader';
import { PublicRoutes } from '../../../config';
import { useCustomStore } from '../../../hooks';
import { SnackBarConfig } from '../../../utils/SnackBarConfig';
import useStyles from '../PublicStyles';

const DeepLink: React.FC = () => {
  const classes = useStyles();
  const { authStore, userStore } = useCustomStore();
  const { enqueueSnackbar } = useSnackbar();
  const useNavigator = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const { screen, id } = useParams();
  const [deepLinkAs, setDeepLinkAs] = React.useState<{
    idParam: string | null | undefined;
    screenParam: string | null | undefined;
  }>({
    idParam: '',
    screenParam: '',
  });

  useEffect(() => {
    setDeepLinkAs({ idParam: id, screenParam: screen });
  }, [screen, id]);

  useEffect(() => {
    const callAPI = async () => {
      try {
        setLoading(true);
        const link = window.location.href;
        // https://simplex-dev-client-portal.azurewebsites.net/dl/t/8153157611
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        // const link = `https://simplex-dev-client-portal.azurewebsites.net/dl/${screen}/${id}`;
        // `https://simplexhub.net/dl/${screen}/${id}`;
        const screenURL = link
          .replace(window.location.origin, '')
          .replace('/dl/', '')
          .replace('/', '');
        if (
          screenURL === 't' ||
          screenURL === 'v' ||
          screenURL === 'i' ||
          screenURL === 'a' ||
          screenURL === 'c'
        ) {
          const result = {
            value: {
              response: {
                activityId: '',
                companyId: authStore.getTokenDetail?.companyId,
                driverId: authStore.getTokenDetail?.id,
                message: undefined,
                regarding: '',
                textLink: link,
                todoId: '',
              },
            },
          };
          userStore.setDeepLink(true, screen!);
          userStore.setDeepLinkData(result.value.response);
        } else {
          const deepLinkResponse = await userStore._getDeepLink(link);
          setLoading(false);
          if (deepLinkResponse.isErr()) {
            enqueueSnackbar(String('Invalid Link'), SnackBarConfig('e'));
          } else {
            userStore.setDeepLink(true, screen!);
          }
        }

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useNavigator(PublicRoutes.LOGIN);
      } catch (error) {
        enqueueSnackbar(String('Invalid Link Catch'), SnackBarConfig('e'));
      }
    };
    callAPI();
  }, [
    deepLinkAs,
    enqueueSnackbar,
    id,
    screen,
    useNavigator,
    userStore,
    authStore,
  ]);

  return (
    <Grid
      container
      spacing={0}
      height={'100vh'}
      direction={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      className={classes.sliderHome}>
      <Grid item margin={'auto'}>
        <div className={classes.rectangle}>
          <img alt="logo" src={logoNav2} className={classes.logoNav2} />
          {loading ? (
            <Loader
              className={'flex-centering mt-1em mb-1em'}
              style={{ color: '#DEC330', marginBottom: 16, marginTop: 16 }}
            />
          ) : (
            'Redirecting'
          )}
          <Grid
            sx={{
              marginTop: '31px',
            }}>
            <Grid container>
              <Box className={classes.labels}>Verifying</Box>
              <Grid item md={12} sm={12} xs={12} />
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
};
export default DeepLink;
